<template>
  <transition name="modal" appear>
    <div :class='[isSPAttachCls + "modal", isSPAttachCls + "modal-overlay"]' class="modal modal-overlay" @click.self="$emit('close') && stopStream()">
      <div :class='isSPAttachCls +"modal-window"' id="modal">
        <p v-if="!isSP" class="modal-window-title"></p>
        <p v-if="!isSP" class="modal-window-subtitle"></p>
        <div v-if="calledComponentName==='HistoryMain'" class="back-button" style="display:none;" @click="backMovie()">
          <span v-if="!isSP" class="back-button-parts"><span class="back-button-parts2">|</span>▲</span>
        </div>
        <div v-if="calledComponentName==='HistoryMain'" class="next-button" style="display:none;" @click="nextMovie()">
          <span v-if="!isSP" class="next-button-parts">▲<span class="next-button-parts2">|</span></span>
        </div>
        <div :class='isSPAttachCls +"modal-content"'>
          <div :id='isSPAttachCls + "closeButton"' @click="$emit('close') && stopStream()">×</div>
          <div id="loadMovieMessage" v-if="isLoadMovie">しばらくお待ちください</div>
          <video v-if="isSP" id="videojs" :class='[isSPAttachCls + "videojs-content", selectedMovie]' class="videojs player video-js vjs-default-skin modalvideo" controls playsinline muted loop disablepictureinpicture></video>
          <video v-else id="videojs" :class='[isSPAttachCls + "videojs-content", selectedMovie]' class="videojs player video-js vjs-default-skin modalvideo" v-on:ended="onEnded" controls muted autoplay disablepictureinpicture></video>
          <slot/>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import $ from 'jquery'// eslint-disable-line
import Hls from "hls.js";
import isMobile from '../../js/modules/componentDeviceUtility.js'
import componentScrollControl from '../../js/modules/componentScrollControl.js'

export default ({
  name: 'LiveModal',
  data() {
    return {
      // ウィンドウのサイズを保持するために使用
      height: window.innerHeight,

      // スマホやタブレットである場合の判定変数
      isSP: isMobile.isMobile(),

      // hlsjsを機能させるための初期化処理を格納した変数
      instantiateHls: new Hls(),// eslint-disable-line

      // 動画がロードされているか判定
      isLoadMovie: true,
    }
  },
  props: {
    // 親コンポーネントより、// モーダルに渡す動画URL情報の配列（動画再生エンドポイントURLなどを格納）
    videoUrlList: {
      type: Array
    },

    // 親コンポーネントより、選択された端末情報を取得
    selectedMovie: {
      type: Number
    },

    // 親コンポーネントより、選択された端末IDを取得
    selectVideo: {
      type: Object
    },

    // 呼ばれる親コンポーネント情報を格納する場所
    calledComponentName: {
      type: String
    }
  },
  methods: {
    /**********************************************************/
    // 取得したURLでhls.js動画処理実行
    /**********************************************************/
    // 引数
    // url : 動画URL
    /**********************************************************/
    updataVideo(url) {
      // ビュー全体がレンダリングされるまで待つ
      this.$nextTick(function () {
        var video = $('#videojs').get(0);
        if(Hls.isSupported()) {// eslint-disable-line
          var hls = this.instantiateHls;
          hls.attachMedia(video);
          hls.on(Hls.Events.MEDIA_ATTACHED, function () {// eslint-disable-line
            hls.loadSource(url);
            hls.on(Hls.Events.MANIFEST_PARSED, function () {// eslint-disable-line
              setTimeout(function(){
                video.play();
              },1000);
            });
          });
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = url;
          video.addEventListener('loadedmetadata',function() {
            setTimeout(function(){
              video.play();
            },1000);
          });
        }
        this.isLoadMovie = false;
      })
    },

    /**********************************************************/
    // ストリーミング再生停止処理
    /**********************************************************/
    // ライブ画面を離れた時に処理をする
    /**********************************************************/
    stopStream() {
      this.$nextTick(function () {
          componentScrollControl.return_scroll();
      })
      // hls.jsで動作させる場合の処理（動画停止）
      this.instantiateHls.destroy();
    },

    /**********************************************************/
    // 連続再生で再生中の動画が終了した際の処理
    /**********************************************************/
    onEnded() {
      this.$emit('checkEndedMovie', true);
    },

    /**********************************************************/
    // 連続再生で前の動画が選択した際の処理
    /**********************************************************/
    backMovie() {
      this.$emit('checkBackMovie', true);
    },

    /**********************************************************/
    // 連続再生で次の動画が選択した際の処理
    /**********************************************************/
    nextMovie() {
      this.$emit('checkEndedMovie', true);
    },
  },
  computed: {
    /*******************************************************************/
    // アクセスしてきている端末がスマホの場合に付加するclass情報
    /*******************************************************************/
    isSPAttachCls() {
      var attachedCls = ""
      // スマホである場合にスマホ用クラスを読み込ませるために情報付加
      if(this.isSP){
        attachedCls = "sp-"
      }
      return attachedCls
    }
  },
  watch: {
    /******************************************************************************/
    // 動画再生エンドポイントURLなどを格納した配列に変化があったときに実行される処理
    /******************************************************************************/
    // 連想配列は、深い階層まで監視してくれない。
    // そのため、動画URLを管理している連想配列:videoUrlListを変更
    // しても、前のデータが残ってしまい想定していた映像が再生されない
    // 場合がある。videoUrlListをdeep: trueで監視(watch)して、
    // 特定の条件下でのみ、処理が走るように対応
    /******************************************************************************/
    videoUrlList:{
        handler() {
          // 動画再生のための情報を格納するための変数
          let video = null
          // selectedMovieをインデックスに使うとthis.videoUrlListの該当端末とのズレが生じるため端末IDで一致した動画を取得するように変更
          for (var i = 0; i < this.videoUrlList.length; i++) {
            // HistoryMainコンポーネントからコールされた場合に、端末IDでどのカメラが選択されたか判断
            if(this.calledComponentName !== "HistoryMain" ){
              if (this.videoUrlList[i][0].platform_term_id == this.selectVideo.term_id) {
                video = this.videoUrlList[i][0];
                if(!this.isSP){
                  var liveTermName = document.getElementById("term-name_" + String(this.videoUrlList[i][0].platform_term_id)).innerText;
                  if(liveTermName.indexOf('▶ライブ') === 0){
                    document.getElementsByClassName('modal-window-title')[0].innerHTML = liveTermName.slice(4);
                  } else {
                    document.getElementsByClassName('modal-window-title')[0].innerHTML = liveTermName.slice(1);
                  }
                  document.getElementsByClassName('modal-window-subtitle')[0].innerHTML = "ライブ";
                }
                break;
              }
            }else{
              // Mainコンポーネントなどからコールされた場合に、端末リストのkeyでどのカメラが選択されたか判断
              if(i === this.selectVideo.key){
                video = this.videoUrlList[i][0];
                this.$nextTick(function () {
                  let dateTime = new Date(this.selectVideo.datetime * 1000);
                  var year = dateTime.getFullYear();
                  var month = dateTime.getMonth()+1;
                  var date = dateTime.getDate();
                  var hour = dateTime.getHours();
                  var min = dateTime.getMinutes();

                  if(!this.isSP){
                    if (document.getElementsByClassName('term-name')[0] !== undefined) {
                      var historyTermName = document.getElementsByClassName('term-name')[0].textContent;
                      if(historyTermName.indexOf('●動画') === 0){
                        document.getElementsByClassName('modal-window-title')[0].innerHTML = historyTermName.slice(3);
                      } else {
                        document.getElementsByClassName('modal-window-title')[0].innerHTML = historyTermName.slice(1);
                      }
                      document.getElementsByClassName('modal-window-subtitle')[0].innerHTML = year + "/" + ('0' + month).slice(-2) + "/" + ('0' + date).slice(-2) + " " + ('0' + hour).slice(-2) + ":" + ('0' + min).slice(-2);
                    }
                  }
                })
                break;
              }
            }
          }

          const url = video.endpoint_url;
          // 動画再生のためのエンドポイントURLが取得できた時の処理
          if(url !== false){
            this.isLoadMovie = true;
            this.updataVideo(url);
          } else {
            this.isLoadMovie = false;
          }
        },
        deep: true
    }
  }
})
</script>

<style lang="scss" scoped>
@import url(../../assets/css/modal/LiveModal.css);
</style>